import { getRouterSelectors } from '@ngrx/router-store';

export const RouterSelectors = {
  ...getRouterSelectors(),
};
